// extracted by mini-css-extract-plugin
export default {"axis_container":"ProfileLifeAxis_axis_container__pihZw","life_axis":"ProfileLifeAxis_life_axis__vC6hd","life_axis_item":"ProfileLifeAxis_life_axis_item__U8DFv"};